import { Fetcher } from 'openapi-typescript-fetch';
export const vmsFetch = Fetcher.for();
let token = '';
let expiresOn;
let authCallback;
// default vms-api for local development
const localUrl = 'http://localhost:3333/v1';
const getBaseUrl = () => {
    // we can't infer baseUrl due to missing window (eg. nodejs)
    if (typeof window === 'undefined') {
        return localUrl;
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!window.location) {
        return localUrl;
    }
    let baseUrl = 'https://api.{env}.vms.legogroup.io/v1';
    const origin = window.location.origin;
    if (origin.includes('localhost') || origin.includes('http://127.0.0.1/')) {
        return localUrl;
    }
    if (origin.includes('dev')) {
        baseUrl = baseUrl.replace('{env}', 'dev');
    }
    else if (origin.includes('prod')) {
        baseUrl = baseUrl.replace('{env}', 'prod');
    }
    else {
        return localUrl;
    }
    return baseUrl;
};
const baseUrl = getBaseUrl();
vmsFetch.configure({
    baseUrl,
});
const timeoutMiddleware = (timeout = 45 * 1000) => {
    return async (url, init, next) => {
        const controller = new AbortController();
        // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
        const id = setTimeout(() => {
            controller.abort(`The request took too long to complete (${Math.floor(timeout / 1000)}s)`);
        }, timeout);
        init.signal = controller.signal;
        // eslint-disable-next-line node/callback-return
        const response = await next(url, init);
        clearTimeout(id);
        return response;
    };
};
const basicAuth = async (url, init, next) => {
    init.headers.append('Authorization', `Basic ${token}`);
    return await next(url, init);
};
// takes a token and puts it in the auth header with bearer
const bearerTokenAuth = async (url, init, next) => {
    init.headers.append('Authorization', `Bearer ${token}`);
    return await next(url, init);
};
// if token has an expiration, handle getting a new one
const authRefreshToken = async (url, init, next) => {
    if (expiresOn) {
        const diff = new Date().getTime() - expiresOn.getTime(); // in mili secs
        const diffInSeconds = diff / 1000;
        if (diffInSeconds > 1800) {
            token = await authCallback();
            expiresOn = new Date();
        }
    }
    else {
        token = await authCallback();
        expiresOn = new Date();
    }
    return await next(url, init);
};
export const initialize = (url, config) => {
    const useTimeout = timeoutMiddleware(config.timeout);
    if (config.token) {
        token = config.token;
        vmsFetch.configure({
            baseUrl: url,
            use: [config.isBasicAuth ? basicAuth : bearerTokenAuth, useTimeout],
        });
        return;
    }
    else if (config.authCallback) {
        authCallback = config.authCallback;
        vmsFetch.configure({
            baseUrl: url,
            use: [authRefreshToken, bearerTokenAuth, useTimeout],
        });
        return;
    }
    vmsFetch.configure({
        baseUrl: url,
        use: [useTimeout],
    });
    return;
};
//# sourceMappingURL=fetch.js.map